import { Box, Grid, Typography } from '@mui/material';
import CustomInput from 'app/components/CustomInput';
import { useFormContext } from 'react-hook-form';
import styles from 'app/components/TextArea/textarea.module.css';
import { FormFieldValues } from 'app/pages/anipay/model/types';
import NewPaymentFileUpload from 'app/pages/anipay/new-payment/ui/assignment-details/file-upload/new-payment.file-upload';
import { useTranslation } from 'react-i18next';

const AssignmentDetails = () => {
  const { t } = useTranslation();

  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<FormFieldValues>();

  const maxLength = 140;
  const descValue = watch('description');

  return (
    <>
      <Grid container columns={1} spacing={3} sx={{ maxWidth: '670px' }}>
        <Grid item xs={12} md={6}>
          <CustomInput
            title={t('commonTerms.contractNumber')}
            placeholder={t('commonTerms.contractNumber')}
            rest={{ ...register('contract_no') }}
            isValid={!!errors.contract_no?.message}
            errorText={errors.contract_no?.message}
          />
        </Grid>
        <Grid sx={{ display: 'flex', gap: '12px', flexDirection: 'column' }} item xs={12} md={6}>
          <Typography sx={{ fontSize: '15px', fontWeight: 400 }}>{t('salary.paymentDestination')}</Typography>
          <Box sx={{ position: 'relative' }}>
            <textarea {...register('description')} className={styles.textarea} maxLength={maxLength} />
            <Typography sx={{ position: 'absolute', bottom: '12px', right: '12px', color: 'rgba(20, 25, 31, 0.56)' }}>
              {descValue?.length ?? 0}/{maxLength}
            </Typography>
          </Box>
          {errors.description?.message && (
            <Typography sx={{ color: 'red', fontSize: '14px' }}>{errors.description.message}</Typography>
          )}
        </Grid>
      </Grid>
      <Grid container columns={1} spacing={3} sx={{ maxWidth: '670px' }} mt={2}>
        <Grid item xs={12} md={9}>
          <NewPaymentFileUpload />
        </Grid>
      </Grid>
    </>
  );
};

export default AssignmentDetails;
